var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 2.41502C14.7898 2.41502 2.41502 14.7898 2.41502 30C2.41502 45.2102 14.7898 57.585 29.9966 57.585C45.2033 57.585 57.5815 45.2102 57.5815 30C57.5815 14.7898 45.2102 2.41502 30 2.41502ZM30 60C13.4566 60 0 46.54 0 30C0 13.46 13.4566 0 30 0C46.5434 0 60 13.4566 60 30C60 46.5434 46.54 60 30 60Z",
    fill: "#FF6B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 20.625L25.3125 37.8125L17.5 30",
    stroke: "#FF6B00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9169 56.2238C21.7314 56.2238 10.2364 45.2075 10.2364 31.6177C10.2364 18.028 21.7314 7.01632 35.9169 7.01632C43.4931 7.01632 50.2966 10.1585 55 15.1562C49.833 7.25408 40.6719 2 30.2229 2C14.0839 2 1 14.5361 1 30C1 45.4639 14.0839 58 30.2229 58C34.6093 58 38.7699 57.0676 42.5025 55.4079C40.4024 55.9394 38.1953 56.2284 35.9169 56.2284V56.2238Z",
    fill: "#FF6B00",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2102 56.2238C23.4993 56.2238 15 45.0897 15 31.5C15 17.9103 23.4993 7.01632 38.2102 7.01632C46.0669 7.01632 51.1224 12.0023 56 17C50.6416 9.0979 43.1412 2 32.3053 2C15.5685 2 0 14.5361 0 30C0 45.4639 15.5685 58 32.3053 58C36.8541 58 41.1688 57.0676 45.0396 55.4079C42.8618 55.9394 40.5729 56.2284 38.2102 56.2284V56.2238Z",
    fill: "#FF6B00",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSuccess);
export default __webpack_public_path__ + "static/media/feedbackSuccess.0632879f71a0ffd89d686bd99b3347ed.svg";
export { ForwardRef as ReactComponent };